/**
 * Checks to see if a column is sortable if it is being built from sortable details
 * Checks the list of sortable columns first to see if the column is in the list
 * If there isn't a list then all columns are included
 * @param sortableDetails
 * @param column
 */
export const columnIsInSortableDetails = (sortableDetails, column) => {
  if (sortableDetails.sortableColumns) {
    return sortableDetails.sortableColumns.includes(column.dataIndex);
  }
  return true;
};